<template>
    <div class="login-page">
        <div class="login-card-center flex">
            <div class="login-card-left">
                <div class="login-card-left-bg"></div>
            </div>
            <div class="login-card-right">
                <el-form
                    :model="form"
                    :rules="rules"
                    ref="form"
                    label-position="top"
                    class="login-card-right-form"
                    @submit.native.prevent="login">
                    <el-form-item>
                        <el-input
                            :autofocus="true"
                            :placeholder="$t('Other.login.accountNumber')"
                            v-model="form.account"
                        ></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input
                            :placeholder="$t('Other.login.Password')"
                            type="password"
                            v-model="form.password"
                        ></el-input>
                    </el-form-item>
                    <div class="flex">
                        <el-form-item class="login-card-code" prop="code">
                            <el-input
                                :placeholder="$t('Fill.code')"
                                type="text"
                                v-model="form.code"
                            ></el-input>
                        </el-form-item>
                        <img :src="codeImg" class="login-code-image" @click="refreshCodeImg()">
                    </div>
                    <div
                        @click="handleForgot()"
                        class="login-forgot-password cursor-pointer text-right">
                        {{ $t('Login.forgot') }}
                    </div>
                    <el-button
                        class="login-card-btn"
                        type="primary"
                        native-type="submit"
                        :loading="isBtnLoading"
                    >
                        {{btnText}}
                    </el-button>
                </el-form>
            </div>
        </div>

        <forgot-password ref="forgot" />
    </div>
</template>

<script>
import { Input, Switch, Form, FormItem, Col, Row } from 'element-ui';
import forgotPassword from '@/components/Dialog/forgotPassword';

export default {
    components: {
        ElInput: Input,
        ElSwitch: Switch,
        ElForm: Form,
        ElFormItem: FormItem,
        ElCol: Col,
        ElRow: Row,
        forgotPassword,
    },
    props: [],
    data() {
        return {
            codeImg: '',
            form: {
                account: '',
                password: '',
                remember: false,
            },
            rules: {
                account: [
                    { required: true, message: this.$t('Other.login.accountNumber'), trigger: 'blur' },
                ],
                password: [
                    { required: true, message: this.$t('Other.login.Password'), trigger: 'blur' },
                ],
            },
            isBtnLoading: false,
        };
    },
    computed: {
        btnText() {
            if (this.isBtnLoading) return this.$t('Other.login.Landing');
            return this.$t('Other.login.Land');
        },
    },
    watch: {},
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            const goLogin = to.path === '/login' || to.path === '/login/';
            if (goLogin && sessionStorage.getItem('my/profile')) {
                vm.$store.dispatch('getMy');
                return next('/');
            }
        });
    },
    methods: {
        login() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                this.isBtnLoading = true;
                API.post('auth/login', this.form).then((res) => {
                    if (res && res.id) {
                        this.$store.commit('setMy', res);
                        this.$router.push('/');
                    } else {
                        $ele.$message.error(this.$t('Other.login.account_password_err'));
                    }
                }).catch(err => {
                    this.refreshCodeImg();
                    $ele.$message.error(err.message);
                }).finally(() => {
                    this.isBtnLoading = false;
                });
            });
        },
        refreshCodeImg() {
            this.codeImg = `${API.base_url}/kaptcha?${Math.random()}`;
        },
        handleForgot() {
            this.$refs.forgot.open();
        },
    },
    mounted() {
        this.refreshCodeImg();
    },
};
</script>

<style lang="scss">
    .login-page {
        width: 100vw;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: left;
        background-image: url('../assets/images/login-pages.png');
        background-size: cover;
        background-position: center;

        .login-card-center {
            width: 800px;
            height: 482px;
            border-radius: 8px;
        }

        .login-card-left {
            width: 304px;
            height: 100%;
            flex: 0 0 auto;
        }

        .login-card-left-bg {
            width: 100%;
            height: 100%;
            background-image: url('../assets/images/login_left.png');
            background-size: cover;
            background-position: center;
        }

        .login-card-right {
            width: 100%;
            height: 100%;
            background: #fff;
            border-top-right-radius: 8px;
            border-bottom-right-radius: 8px;
        }

        .login-card-code {
            width: 173px;
            flex: 0 0 auto;
        }

        .login-code-image {
            width: 83px;
            height: 35px;
        }

        .login-card-btn {
            width: 100%;
            margin-top: 24px;
            height: 52px;
            font-size: 14px;
        }

        .login-forgot-password {
            font-size: 12px;
            color: #333;
        }
    }
    .login-card-right-form {
        position: relative;
        top: 50%;
        left: 50%;
        width: 260px;
        transform: translate(-50%, -50%);
        .el-input__inner {
            border: none !important;
            border-bottom: 1px solid #E6E6E6 !important;
            font-size: 14px !important;
            padding: 17px 0;
        }
    }
</style>
